<div style="overflow:auto; width:100%; height:130%">
  <!-- <app-subnav></app-subnav> -->

  <div class="container" style="text-align: justify; ">
    <h3>
      PRIVACY POLICY
    </h3>
    <p>
      This privacy policy applies between you, the User of this Website and Foodbud Limited, the owner and provider of
      this Website. Foodbud Limited takes the privacy of your information very seriously. This privacy policy applies to
      our use of any and all Data collected by us or provided by you in relation to your use of the Website.
      This privacy policy should be read alongside, and in addition to, our Terms and Conditions, which can be found
      at: <a href="https://foodbud.app/#/public/terms">www.foodbud.app/terms.</a>  
    </p>
    <h4>Please read this privacy policy carefully.</h4>
    <h4>Definitions and interpretation</h4>

    <li>In this privacy policy, the following definitions are used:</li>
    <br>
    <table class="table table-bordered">
      <tr>
        <td>Data</td>
        <td>collectively all information that you submit to Foodbud Limited via the Website. This definition
          incorporates, where applicable, the definitions provided in the Data Protection Laws;</td>
      </tr>
      <tr>
        <td>Cookies</td>
        <td>a small text file placed on your computer by this Website when you visit certain parts of the Website and/or
          when you use certain features of the Website. Details of the cookies used by this Website are set out in the
          clause below ( Cookies);</td>
      </tr>
      <tr>
        <td>Data Protection Laws</td>
        <td>any applicable law relating to the processing of personal Data, including but not limited to the GDPR, and
          any national implementing and supplementary laws, regulations and secondary legislation;</td>
      </tr>
      <tr>
        <td>GDPR</td>
        <td>the UK General Data Protection Regulation;</td>
      </tr>
      <tr>
        <td>Foodbud Limited,we  or us</td>
        <td>Foodbud Limited, a company incorporated in England and Wales with registered number 13163110 whose
          registered office is at 9 Pye Terrace,  Cambridge,   CB4 1DX; </td>
      </tr>
      <tr>
        <td> UK and UK Cookie Law</td>
        <td>
          The Privacy and Electronic Communications (EC Directive) Regulations 2003 as amended by the Privacy and
          Electronic Communications (EC Directive) (Amendment) Regulations 2011 & the Privacy and Electronic
          Communications (EC Directive) (Amendment) Regulations 2018; </td>
      </tr>
      <tr>
        <td>User or you</td>
        <td>Any third party that accesses the Website and is not either (i) employed by Foodbud Limited and acting in
          the course of their employment or (ii) engaged as a consultant or otherwise providing services to Foodbud
          Limited and accessing the Website in connection with the provision of such services; and</td>
      </tr>
      <tr>
        <td>Website</td>
        <td>the website that you are currently using, www.foodbud.app, and any sub-domains of this site unless expressly
          excluded by their own terms and conditions.</td>
      </tr>
    </table>
    <ol>
      <li>
        In this privacy policy, unless the context requires a different interpretation:
      </li>
      <ol type="a">
        <li>the singular includes the plural and vice versa;</li>
        <li>references to sub-clauses, clauses, schedules or appendices are to sub-clauses, clauses, schedules or
          appendices of this privacy policy;</li>
        <li>a reference to a person includes firms, companies, government entities, trusts and partnerships;</li>
        <li>"including" is understood to mean "including without limitation";</li>
        <li>reference to any statutory provision includes any modification or amendment of it;</li>
        <li>the headings and sub-headings do not form part of this privacy policy.</li>
      </ol>
      <h4>Scope of this privacy policy</h4>
      <li>
        This privacy policy applies only to the actions of Foodbud Limited and Users with respect to this Website. It
        does
        not extend to any websites that can be accessed from this Website including, but not limited to, any links we
        may
        provide to social media websites.
      </li>
      <li>For purposes of the applicable Data Protection Laws, Foodbud Limited is the "data controller". This means
        that Foodbud Limited determines the purposes for which, and the manner in which, your Data is processed.</li>
      <h4>Data collected</h4>

      <li>We may collect the following Data, which includes personal Data, from you:</li>
      <ol type="a">
        <li>name;</li>
        <li>date of birth;</li>
        <li>gender;</li>
        <li>contact Information such as email addresses and telephone numbers;</li>
        <li>demographic information such as postcode, preferences and interests;</li>
        <li>IP address (automatically collected);</li>
        <li>Food allergies and Dietary preferences;</li>
      </ol>
      <p>in each case, in accordance with this privacy policy.</p>
      <h4>How we collect Data</h4>
      <li>We collect Data in the following ways:</li>
      <ol type="a">
        <li>data is given to us by you  ; and</li>
        <li>data is collected automatically.</li>
      </ol>
      <h4>Data that is given to us by you</h4>
      <li>Foodbud Limited will collect your Data in a number of ways, for example:</li>
      <ol type="a">
        <li>when you contact us through the Website, by telephone, post, e-mail or through any other means;</li>
        <li>when you register with us and set up an account to receive our products/services;</li>
        <li>when you use our services;</li>
      </ol>
      <p>in each case, in accordance with this privacy policy.</p>
      <h4>Data that is collected automatically</h4>
      <li>To the extent that you access the Website, we will collect your Data automatically, for example:</li>
      <ol type="a">
        <li>we automatically collect some information about your visit to the Website. This information helps us to make
          improvements to Website content and navigation, and includes your IP address, the date, times and frequency
          with
          which you access the Website and the way you use and interact with its content.</li>
        <li>we will collect your Data automatically via cookies, in line with the cookie settings on your browser. For
          more information about cookies, and how we use them on the Website, see the section below, headed "Cookies".
        </li>
      </ol>
      <h4>Our use of Data</h4>
      <li>Any or all of the above Data may be required by us from time to time in order to provide you with the best
        possible service and experience when using our Website. Specifically, Data may be used by us for the following
        reasons:</li>
      <ol type="a">
        <li> improvement of our products / services;</li>
        <li>contact for market research purposes which may be done using email, telephone, fax or mail. Such information
          may be used to customise or update the Website;</li>
      </ol>
      <p>in each case, in accordance with this privacy policy.</p>
      <li>We may use your Data for the above purposes if we deem it necessary to do so for our legitimate interests. If
        you are not satisfied with this, you have the right to object in certain circumstances (see the section headed
        "Your rights" below).</li>
      <li>When you register with us and set up an account to receive our services, the legal basis for this processing
        is
        the performance of a contract between you and us and/or taking steps, at your request, to enter into such a
        contract.</li>
      <h4>Who we share Data with</h4>

      <li>We may share your Data with the following groups of people for the following reasons:</li>
      <ol type="a">
        <li>any of our group companies or affiliates - to ensure proper administration and functioning of our product
          and
          services to enable personalized recommendations;</li>
        <li>relevant authorities - to facilitate the detection of crime ;</li>
      </ol>
      <p>in each case, in accordance with this privacy policy.</p>
      <h4>Keeping Data secure</h4>
      <li>We will use technical and organisational measures to safeguard your Data, for example:</li>
      <ol type="a">
        <li>access to your account is controlled by a password and a user name that is unique to you.</li>
        <li>we store your Data on secure servers.</li>
      </ol>
      <li>Technical and organisational measures include measures to deal with any suspected data breach. If you suspect
        any misuse or loss or unauthorised access to your Data, please let us know immediately by contacting us via this
        e-mail address: info@foodbud.ai.</li>
      <h4>Data retention</h4>
      <li>Unless a longer retention period is required or permitted by law, we will only hold your Data on our systems
        for
        the period necessary to fulfil the purposes outlined in this privacy policy or until you request that the Data
        be
        deleted .</li>
      <li>Even if we delete your Data, it may persist on backup or archival media for legal, tax or regulatory purposes.
      </li>
      <h4>Your rights</h4>
      <li>You have the following rights in relation to your Data:</li>
      <ol type="a">
        <li>
          <span>Right to access -</span>
          the right to request (i) copies of the information we hold about you at any time, or (ii) that
          we modify, update or delete such information. If we provide you with access to the information we hold about
          you, we will not charge you for this, unless your request is "manifestly unfounded or excessive." Where we are
          legally permitted to do so, we may refuse your request. If we refuse your request, we will tell you the
          reasons
          why.
        </li>
        <li>
          <span>Right to correct -</span>
          the right to have your Data rectified if it is inaccurate or incomplete.
        </li>
        <li> <span> Right to erase - </span>
          the right to request that we delete or remove your Data from our systems.</li>
        <li> <span> Right to restrict our use of your Data -</span>
          the right to "block" us from using your Data or limit the way in
          which we can use it.</li>
        <li><span>Right to data portability -</span> the right to request that we move, copy or transfer your Data.</li>
        <li> <span> Right to object - </span>
          the right to object to our use of your Data including where we use it for our legitimate
          interests.</li>
      </ol>
      <li>To make enquiries, exercise any of your rights set out above, or withdraw your consent to the processing of
        your
        Data (where consent is our legal basis for processing your Data), please contact us via this e-mail
        address: info@foodbud.ai.</li>
      <li>If you are not satisfied with the way a complaint you make in relation to your Data is handled by us, you may
        be
        able to refer your complaint to the relevant data protection authority. For the UK, this is the Information
        Commissioner's Office (ICO). The ICO's contact details can be found on their website at https://ico.org.uk/.
      </li>
      <li>It is important that the Data we hold about you is accurate and current. Please keep us informed if your Data
        changes during the period for which we hold it.</li>
      <h4>Links to other websites</h4>
      <li>This Website may, from time to time, provide links to other websites. We have no control over such websites
        and
        are not responsible for the content of these websites. This privacy policy does not extend to your use of such
        websites. You are advised to read the privacy policy or statement of other websites prior to using them.</li>
      <h4>Changes of business ownership and control</h4>
      <li>Foodbud Limited may, from time to time, expand or reduce our business and this may involve the sale and/or the
        transfer of control of all or part of Foodbud Limited. Data provided by Users will, where it is relevant to any
        part of our business so transferred, be transferred along with that part and the new owner or newly controlling
        party will, under the terms of this privacy policy,
        be permitted to use the Data for the purposes for which it was originally supplied to us.</li>
      <li>We may also disclose Data to a prospective purchaser of our business or any part of it.</li>
      <li>In the above instances, we will take steps with the aim of ensuring your privacy is protected.</li>
      <h4>Cookies</h4>
      <li>This Website may place and access certain Cookies on your computer.     Foodbud Limited uses Cookies to
        improve
        your experience of using the Website and to improve our range of services.  Foodbud Limited has carefully chosen
        these Cookies and has taken steps to ensure that your privacy is protected and respected at all times.</li>
      <li> All Cookies used by this Website are used in accordance with current UK and EU Cookie Law.</li>
      <li> Before the Website places Cookies on your computer, you will be presented with a message bar requesting your
        consent to set those Cookies. By giving your consent to the placing of Cookies, you are enabling Foodbud
        Limited to provide a better experience and service to you. You may, if you wish, deny consent to the placing of
        Cookies; however certain features of the Website may not function fully or as intended.</li>
      <li>This Website may place the following Cookies:</li>
      <br>
      <table class="table table-bordered">
        <tr>
          <th>Type of Cookie</th>
          <th>Purpose</th>
        </tr>
        <tr>
          <td>Strictly necessary cookies</td>
          <td>These are cookies that are required for the operation of our website. They include, for example, cookies
            that enable you to log into secure areas of our website, use a shopping cart or make use of e-billing
            services.</td>
        </tr>
        <tr>
          <td>Analytical/performance cookies</td>
          <td>They allow us to recognise and count the number of visitors and to see how visitors move around our
            website when they are using it. This helps us to improve the way our website works, for example, by ensuring
            that users are finding what they are looking for easily.</td>
        </tr>
        <tr>
          <td>Functional cookie</td>
          <td>These are used to recognise you when you return to our website. This enables us to personalise our content
            for you, greet you by name and remember your preferences (for example, your choice of language or region).
          </td>
        </tr>
      </table>
      <li>You can find a list of Cookies that we use in the Cookies Schedule.</li>
      <li>You can choose to enable or disable Cookies in your internet browser. By default, most internet browsers
        accept
        Cookies but this can be changed. For further details, please consult the help menu in your internet browser.
      </li>
      <li>You can choose to delete Cookies at any time; however you may lose any information that enables you to access
        the Website more quickly and efficiently including, but not limited to, personalisation settings.</li>
      <li>It is recommended that you ensure that your internet browser is up-to-date and that you consult the help and
        guidance provided by the developer of your internet browser if you are unsure about adjusting your privacy
        settings.</li>
      <li>For more information generally on cookies, including how to disable them, please refer to aboutcookies.org.
        You
        will also find details on how to delete cookies from your computer.</li>
      <h4>General</h4>
      <li>You may not transfer any of your rights under this privacy policy to any other person. We may transfer our
        rights under this privacy policy where we reasonably believe your rights will not be affected.</li>
      <li>If any court or competent authority finds that any provision of this privacy policy (or part of any provision)
        is invalid, illegal or unenforceable, that provision or part-provision will, to the extent required, be deemed
        to
        be deleted, and the validity and enforceability of the other provisions of this privacy policy will not be
        affected.</li>
      <li>Unless otherwise agreed, no delay, act or omission by a party in exercising any right or remedy will be deemed
        a
        waiver of that, or any other, right or remedy.</li>
      <li>This Agreement will be governed by and interpreted according to the law of England and Wales. All disputes
        arising under the Agreement will be subject to the exclusive jurisdiction of the English and Welsh courts.</li>
      <h4>Changes to this privacy policy</h4>
      <li>Foodbud Limited reserves the right to change this privacy policy as we may deem necessary from time to time or
        as may be required by law. Any changes will be immediately
        posted on the Website and you are deemed to have accepted the terms of the privacy policy on your first use of
        the
        Website following the alterations.  
            You may contact Foodbud Limited by email at <a href="info@foodbud.ai.">info@foodbud.ai.</a></li>
      <h4>Attribution</h4>
      <li> This privacy policy was created using a document from <span>Rocket Lawyer</span> ( <a
          href="https://www.rocketlawyer.com/gb/en">https://www.rocketlawyer.com/gb/en</a>).
        <span>20 April 2021 </span> </li>
      <h4>Cookies</h4>
      <p>Below is a list of the cookies that we use. We have tried to ensure this is complete and up to date, but if you
        think that we have missed a cookie or there is any discrepancy, please let us know.
        Strictly necessary</p>
      <p>We use the following strictly necessary cookies:</p>
      <table class="table table-bordered">
        <tr>
          <th>Description of Cookie</th>
          <th>Purpose</th>
        </tr>
        <tr>
          <td>Session cookie</td>
          <td>We use this session cookie to remember you and maintain your session whilst you are using our website</td>
        </tr>
      </table>
      <p>Analytical/performance
        We use the following analytical/performance cookies:</p>
      <table class="table table-bordered">
        <tr>
          <th>Description of Cookie</th>
          <th>Purpose</th>
        </tr>
        <tr>
          <td>Performance cookies</td>
          <td>We use this cookie to help us analyse how users use the website.</td>
        </tr>
      </table>
      <p>Functionality
        We use the following functionality cookies:</p>
      <table class="table table-bordered">
        <tr>
          <th>Description of Cookie</th>
          <th>Purpose</th>
        </tr>
        <tr>
          <td>Functional cookie</td>
          <td>We use this cookie to identify your computer and analyse traffic patterns on our website.</td>
        </tr>
      </table>
    </ol>
  </div>
</div>